/**
 * Отзывы об аптеке после заказа — контракт ручек (схемы `PendingReview`,
 * `MyReview`, `Review` в `openapi.yaml`, пока только на staging). Бэкенд
 * сделан по этим типам и docs/notes/reviews-contract.md.
 *
 * Покупатель:
 *   GET  /api/v1/me/reviews/pending          — закрытые заказы, которые ещё не оценили и не отказались
 *   POST /api/v1/orders/{id}/review          — оценить заказ (1–5 и комментарий); второй раз → 409 conflict
 *   POST /api/v1/orders/{id}/review/dismiss  — «не сейчас»: больше не спрашивать об этом заказе
 *   GET  /api/v1/orders/{id}/review          — оценка заказа или 404
 * Админка (только роль «Супер-админ», role_id 1; остальным 403):
 *   GET  /api/v1/admin/reviews?page=&page_size=&store_id=&rating= — { items, total, summary }
 */

/** Закрытый заказ, который ждёт оценки. */
export interface PendingReviewDto {
  order_id: number
  order_number: number
  store_id: number | null
  store_name: string
  /** Когда заказ закрыли (выдан или доставлен), ISO 8601. */
  closed_at: string
}

export interface ReviewInput {
  /** 1–5 звёзд. */
  rating: number
  /** Необязательный комментарий, до REVIEW_COMMENT_MAX символов. */
  comment: string
}

/** Оценка заказа — так её видит покупатель. */
export interface MyReviewDto {
  order_id: number
  rating: number
  comment: string
  created_at: string
}

/** Отзыв в админке. */
export interface ReviewDto {
  id: number
  order_id: number
  order_number: number
  store_id: number | null
  store_name: string
  customer_id: number
  customer_name: string
  customer_phone: string
  rating: number
  comment: string
  created_at: string
}

export interface StoreRatingDto {
  store_id: number | null
  store_name: string
  count: number
  /** Средняя оценка, одна цифра после запятой. */
  avg: number
}

export interface ReviewSummaryDto {
  count: number
  avg: number
  /** По аптекам — для фильтра и полосы средних; хуже оценённые сверху. */
  by_store: StoreRatingDto[]
}

export interface ReviewPageDto {
  items: ReviewDto[]
  total: number
  /** Итоги по выборке без учёта страницы (фильтр аптеки и оценки учтён). */
  summary: ReviewSummaryDto
}

export interface AdminReviewsQuery {
  page?: number
  pageSize?: number
  storeId?: number | null
  rating?: number | null
}

export const REVIEW_COMMENT_MAX = 1000
/** Не спрашиваем об оценке заказа, закрытого раньше стольких дней назад. */
export const REVIEW_ASK_DAYS = 14
export const ADMIN_REVIEWS_PAGE_SIZE = 10
/** Роль, которой видны отзывы: «Супер-админ». Права в сетке ролей нет. */
export const REVIEWS_ROLE_ID = 1
